import { CheckBox } from 'src/components/CampaignDetails/CampaignBuilder/InventoryTargeting/CheckBox';

export const RememberMeCheckbox = ({ rememberMe, setRememberMe }) => (
  <button onClick={() => setRememberMe(!rememberMe)} type="button" className="w-full flex py-2 hover:text-primary">
    <CheckBox isSelected={rememberMe} className="flex-grow-0" />
    <p>Remember me?</p>
  </button>
);
